import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "icon"];
  currentTheme = localStorage.getItem("theme") || "light";

  initialize() {
    this.syncWithServer();
  }

  connect() {
    this.apply(this.currentTheme);
    this.toggleTarget.addEventListener("click", this.toggle.bind(this));
  }

  apply(theme) {
    const html = document.documentElement;
    html.setAttribute("data-theme", theme);
    html.classList.remove("light", "dark");
    html.classList.add(theme);
    localStorage.setItem("theme", theme);
  }

  toggle() {
    const newTheme = this.currentTheme === "light" ? "dark" : "light";
    this.apply(newTheme);
    this.currentTheme = newTheme;
    this.postUserSettings(newTheme);
  }

  syncWithServer() {
    const html = document.documentElement;
    const serverTheme = html.getAttribute("data-theme");

    if (serverTheme && serverTheme !== this.currentTheme) {
      this.currentTheme = serverTheme;
      localStorage.setItem("theme", serverTheme);
    }
  }

  postUserSettings(newTheme) {
    fetch("/theme/toggle", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
      body: JSON.stringify({ theme: newTheme }),
    }).catch((error) => {
      console.error("Error posting user settings:", error);
    });
  }
}
